var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutorenew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_9712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_9712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29199 26.375C7.70866 25.375 7.29199 24.3473 7.04199 23.292C6.79199 22.236 6.66699 21.1663 6.66699 20.083C6.66699 16.4163 7.97233 13.2707 10.583 10.646C13.1943 8.02067 16.3333 6.708 20 6.708H21.292L18.167 3.625L20.042 1.75L26.417 8.125L20.042 14.458L18.167 12.583L21.25 9.5H20C17.0833 9.5 14.5973 10.5347 12.542 12.604C10.486 14.6733 9.45799 17.1663 9.45799 20.083C9.45799 20.861 9.53466 21.604 9.68799 22.312C9.84066 23.0207 10.042 23.7083 10.292 24.375L8.29199 26.375ZM19.917 38.333L13.542 31.958L19.917 25.625L21.75 27.458L18.667 30.583H20C22.9167 30.583 25.4027 29.5483 27.458 27.479C29.514 25.4097 30.542 22.9167 30.542 20C30.542 19.222 30.4723 18.479 30.333 17.771C30.1943 17.0623 29.9723 16.3747 29.667 15.708L31.708 13.708C32.264 14.708 32.674 15.736 32.938 16.792C33.2013 17.8473 33.333 18.9167 33.333 20C33.333 23.6667 32.0277 26.8127 29.417 29.438C26.8057 32.0627 23.6667 33.375 20 33.375H18.667L21.75 36.458L19.917 38.333Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenew);
export default __webpack_public_path__ + "static/media/autorenew.710a6f5afeaae686307988e1f41593ba.svg";
export { ForwardRef as ReactComponent };